<template>



    <el-card>
        <div class="announcement-header">
            <div class="announcement-icon">
                <i class="el-icon-location-outline"></i>
            </div>
            <div class="announcement-title">采购清单</div>
        </div>
        <div class="device-table-container">
            <div class="checkin-overview-list">
                <div class="overview-header">
                    <div class="header-item">采购订单编号</div>
                    <div class="header-item">订单状态</div>
                    <div class="header-item">采购订单时间</div>
                    <div class="header-item">物料采购单发布状态</div>


                </div>
                <!-- 滚动列表的视窗容器 -->
                <div class="marquee-container">
                    <div class="overview-body">
                        <div class="overview-row" v-for="(item, index) in paginatedTaskList" :key="index">
                            <div class="body-item">{{ item.orderNo }}</div>
                            <div class="body-item">{{ item.orderStatus }}</div>
                            <div class="body-item">{{ item.alarmName }}</div>
                            <div class="body-item"> {{ item.orderDate }}</div>
                            <div class="body-item"> <el-tag :type="item.status === 1 ? 'info' : 'success'">
                                    {{ item.status == 1 ? '未发布' : '已发布' }}
                                </el-tag></div>

                        </div>
                        <div class="empty-tip" v-if="paginatedTaskList.length === 0">
                            暂无告警记录
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-card>



</template>

<script>
import {
    getRequiredMaterials,

    getMaterialByNo,
    editPurchaseMaterial,
    addPurchaseMaterial,

    calculateLis,
    publishBidding
} from "@/api/Requirement";
import {
    getSupplierList,
} from "@/api/supplier";
import { getAllProducts } from "@/api/ingredients";
export default {

    data() {
        return {
            // 任务搜索表单
            searchForm: { orderNo: "" },
            // 原始任务列表
            taskList: [],
            // 分页参数
            taskCurrentPage: 1,
            taskPageSize: 10,
            taskTotalCount: 0,
            // 原料需求抽屉控制
            materialDrawerVisible: false,
            currentMaterialDemand: [],
            // 发起采购抽屉控制
            purchaseDialogVisible: false,
            purchaseForm: {
                purchaseUnit: "",
                purchaser: "",
                orderDate: null, // 绑定Date对象
                deliveryTime: "",
                orderNo: "",
                totalPrice: 0.00, // 初始化修改采购单总价
            },
            purchaseMaterials: [], // 发起采购时的原料列表
            // 供应商列表 (已改为动态加载)
            suppliers: [],
            // 原料列表
            materialList: [],
            // 表单校验规则
            purchaseFormRules: {
                orderDate: [{ required: true, message: "请选择订购时间", trigger: "change" }], // 修复4：trigger改为change
            },
            // 新增采购单抽屉控制
            addPurchaseDialogVisible: false,
            addPurchaseForm: {
                orderNo: "",
                purchaseUnit: "",
                purchaser: "",
                orderDate: null, // 绑定Date对象
                deliveryTime: "",
                orderStatus: "",
                totalPrice: 0.00, // 初始化订单总价
            },
            addPurchaseMaterials: [
                { index: 1, materialName: "", num: 0.1, unit: "g", unitPrice: 0.01, totalPrice: 0.01, supplierId: "" },
            ],
            addPurchaseFormRules: {
                orderDate: [{ required: true, message: "请选择订购时间", trigger: "change" }], // 修复5：trigger改为change
                orderStatus: [{ required: true, message: "请选择订单状态", trigger: "change" }],
            },
            // 修改采购单抽屉控制
            editDialogVisible: false,
            editForm: {
                id: "",
                orderNo: "",
                orderStatus: "",
                orderDate: null, // 绑定Date对象
                status: "",
            },
            editFormRules: {
                orderNo: [{ required: true, message: "请输入采购订单编号", trigger: "blur" }],
                orderStatus: [{ required: true, message: "请选择订单状态", trigger: "change" }],
                orderDate: [{ required: true, message: "请选择采购订单时间", trigger: "change" }], // 修复6：trigger改为change
                status: [{ required: true, message: "请选择发布状态", trigger: "change" }],
            },
        };
    },
    computed: {
        // 分页后的任务列表
        paginatedTaskList() {
            const startIndex = (this.taskCurrentPage - 1) * this.taskPageSize;
            const endIndex = startIndex + this.taskPageSize;
            return this.taskList.slice(startIndex, endIndex).map((item, index) => ({
                ...item,
                index: startIndex + index + 1,
            }));
        },
    },
    mounted() {
        // 初始化获取任务列表
        this.fetchTaskList();
        // 初始化日期为当前时间（直接赋值Date对象）
        const now = new Date();
        this.addPurchaseForm.orderDate = now;
        this.purchaseForm.orderDate = now;
        // 初始化计算订单总价
        this.calculateOrderTotalPrice();
    },
    created() {
        // 组件创建时，立即获取供应商列表
        this.fetchSuppliers();
        this.fetchMaterialList()
    },
    methods: {
        fetchMaterialList() {
            // this.$loading({ text: "正在加载原料列表..." });
            const userId = localStorage.getItem('userId');

            getAllProducts({ userId })
                .then(response => {
                    const rawMaterials = response.data || [];
                    // 转换为el-select需要的label/value格式
                    this.materialList = rawMaterials.map(item => ({
                        label: item.pname,
                        value: item.pid
                    }));
                    console.log("原料列表加载成功:", this.materialList);
                })
                .catch(error => {
                    console.error('获取原料列表失败:', error);
                    this.$message.error('获取原料列表失败，请重试');
                })
                .finally(() => {
                    this.$loading().close();
                });
        },

        /**
         * 动态获取供应商列表
         */
        fetchSuppliers() {
            const userId = localStorage.getItem("userId");
            if (!userId) {
                console.error("无法获取用户ID，无法加载供应商列表。");
                this.$message.warning("用户信息无效，请刷新页面。");
                return;
            }

            this.$loading({ text: "正在加载供应商数据..." });
            getSupplierList({ userId: userId })
                .then((response) => {
                    this.suppliers = response.data || [];
                    console.log("供应商列表加载成功:", this.suppliers);
                })
                .catch((error) => {
                    console.error("获取供应商列表失败:", error);
                    this.$message.error("获取供应商数据失败，请稍后重试。");
                    this.suppliers = []; // 加载失败时清空，防止显示旧数据
                })
                .finally(() => {
                    this.$loading().close();
                });
        },

        // 发起采购
        InitiateProcurement(row) {
            publishBidding({ userId: localStorage.getItem('userId'), id: row.id }).then((response) => {
                this.$message.success(response.message);
                this.fetchTaskList(); // 成功后刷新列表
            }).catch(() => {
                this.$message.error("发起采购失败");
            });
        },

        // 生成采购单
        procurement() {
            calculateLis().then((response) => {
                this.$message.success(response.message);
            }).catch(() => {
                this.$message.error("生成采购单失败");
            });
        },

        /**
         * 格式化日期为 YYYY-MM-DD HH:mm:ss（用于提交接口）
         */
        formatDate(date) {
            if (!date) return "";
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            const hour = String(date.getHours()).padStart(2, "0");
            const minute = String(date.getMinutes()).padStart(2, "0");
            const second = String(date.getSeconds()).padStart(2, "0");
            return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
        },

        /**
         * 将字符串日期转换为Date对象（用于编辑时回显）
         */
        parseDate(dateStr) {
            if (!dateStr) return null;
            // 修复7：兼容不同的日期字符串格式
            if (typeof dateStr === 'string') {
                // 处理 "YYYY-MM-DD HH:mm:ss" 格式
                return new Date(dateStr.replace(/-/g, '/'));
            }
            return new Date(dateStr);
        },

        /**
         * 获取任务列表
         */
        fetchTaskList() {
            this.$loading({ text: "正在加载数据..." });
            const userId = localStorage.getItem("userId");
            const params = { userId: userId };

            if (this.searchForm.orderNo) {
                params.orderNo = this.searchForm.orderNo;
                getMaterialByNo(params)
                    .then((response) => {
                        this.taskList = response.data || [];
                        this.taskTotalCount = this.taskList.length;
                        if (this.taskTotalCount > 0) {
                            this.$message.success(`找到 ${this.taskTotalCount} 条相关物料记录`);
                        } else {
                            this.$message.info("未找到相关物料记录");
                        }
                    })
                    .catch(this.handleApiError)
                    .finally(() => this.$loading().close());
            } else {
                getRequiredMaterials(params)
                    .then((response) => {
                        this.taskList = response.data || [];
                        this.taskTotalCount = this.taskList.length;
                    })
                    .catch(this.handleApiError)
                    .finally(() => this.$loading().close());
            }
        },

        /**
         * 通用API错误处理
         */
        handleApiError(error) {
            console.error("API调用异常:", error);
            this.$message.error("数据加载失败，请稍后重试。");
            this.taskList = [];
            this.taskTotalCount = 0;
        },

        /**
         * 显示原料需求列表
         */
        showMaterialDemand(row) {
            this.$loading({ text: "正在查询数据..." });
            getMaterialByNo({
                userId: localStorage.getItem("userId"),
                orderNo: row.orderNo,
            })
                .then((response) => {
                    const materials = response.data || [];
                    if (materials.length > 0) {
                        this.currentMaterialDemand = materials;
                        this.materialDrawerVisible = true;
                    } else {
                        this.$message.warning("未找到相关物料信息");
                    }
                })
                .catch((error) => {
                    console.error("查询物料需求异常:", error);
                    this.$message.error("查询物料需求失败，请重试");
                })
                .finally(() => {
                    this.$loading().close();
                });
        },






        /**
         * 任务行点击
         */
        handleTaskRowClick(row) {
            this.$refs.taskTable.toggleRowSelection(row);
        },

        /**
         * 发起采购-加载原料列表
         */
        initiatePurchase(row) {
            this.purchaseForm.orderNo = row.orderNo;
            this.$loading({ text: "正在加载原料信息..." });
            getMaterialByNo({
                userId: localStorage.getItem("userId"),
                orderNo: row.orderNo,
            })
                .then((response) => {
                    const materials = response.data || [];
                    console.log(materials);

                    this.purchaseMaterials = materials.map((material, index) => {
                        // 初始化单价和总价
                        const unitPrice = material.unitPrice || 0.01;
                        const num = material.num || 0.1;
                        const totalPrice = Number((num * unitPrice).toFixed(2));

                        return {
                            index: index + 1,
                            id: material.id,
                            materialName: material.materialName,
                            num: num,
                            unit: material.unit || "g",
                            unitPrice: unitPrice,
                            totalPrice: totalPrice,
                            supplierId: material.supplier || "", // 统一使用 supplierId
                            isEditing: false,
                        };
                    });

                    // 加载完成后计算总价
                    this.calculateOrderTotalPrice('edit');

                    this.purchaseDialogVisible = true;
                    this.$nextTick(() => {
                        this.$refs.purchaseFormRef?.clearValidate();
                    });
                })
                .catch((error) => {
                    console.error("获取采购原料异常:", error);
                    this.$message.error("获取采购原料失败，请重试");
                })
                .finally(() => {
                    this.$loading().close();
                });
        },

        /**
         * 发起采购-新增原料
         */
        addNewMaterial() {
            const newIndex = this.purchaseMaterials.length + 1;
            const newMaterial = {
                index: newIndex,
                id: "",
                materialName: "",
                num: 0.1, // 默认最小数量
                unit: "g",
                unitPrice: 0.01, // 初始化单价
                totalPrice: 0.01, // 初始化总价
                supplierId: "", // 统一使用 supplierId
                isEditing: true,
            };
            this.purchaseMaterials.push(newMaterial);

            // 新增原料后计算总价
            this.calculateOrderTotalPrice('edit');
        },

        /**
         * 发起采购-开始编辑原料
         */
        startEditMaterial(material) {
            material.isEditing = true;
            // 自动聚焦到第一个可编辑项，提升体验
            this.$nextTick(() => {
                const selectEl = document.querySelector(`.el-select__input[aria-label="选择原料名称"]`);
                if (selectEl) selectEl.focus();
            });
        },

        /**
         * 计算单行原料总价（数量 * 单价）
         */
        calculateTotalPrice(material) {
            if (material.num && material.unitPrice) {
                material.totalPrice = Number((material.num * material.unitPrice).toFixed(2));
            } else {
                material.totalPrice = 0;
            }

            // 判断当前是新增还是修改场景，调用对应的总价计算
            if (this.purchaseDialogVisible) {
                this.calculateOrderTotalPrice('edit'); // 修改采购单
            } else if (this.addPurchaseDialogVisible) {
                this.calculateOrderTotalPrice('add'); // 新增采购单
            }
        },

        /**
         * 计算订单总价（所有原料行总价之和）
         * @param {String} type - 场景类型：'add' 新增采购单, 'edit' 修改采购单
         */
        calculateOrderTotalPrice(type = 'add') {
            let materials = [];
            let targetForm = null;

            // 根据类型选择对应的原料列表和表单
            if (type === 'add') {
                materials = this.addPurchaseMaterials;
                targetForm = this.addPurchaseForm;
            } else if (type === 'edit') {
                materials = this.purchaseMaterials;
                targetForm = this.purchaseForm;
            }

            if (materials.length === 0) {
                targetForm.totalPrice = 0.00;
                return;
            }

            // 累加所有原料行的总价
            const total = materials.reduce((sum, item) => {
                return sum + (item.totalPrice || 0);
            }, 0);

            // 保留两位小数
            targetForm.totalPrice = Number(total.toFixed(2));
        },

        /**
         * 发起采购-单价变化时自动计算总价
         */
        handlePriceChange(material) {
            this.calculateTotalPrice(material);
        },

        /**
         * 发起采购-采购数量变化
         */
        handleWeightChange(material) {
            if (material.num < 0.1) {
                material.num = 0.1; // 确保数量不小于最小值
            }
            // 数量变化时重新计算总价
            this.calculateTotalPrice(material);
        },

        /**
         * 新增采购单-单价变化时自动计算总价
         */
        handleAddPurchasePriceChange(material) {
            this.calculateTotalPrice(material);
        },

        /**
         * 新增采购单-采购数量变化
         */
        handleAddPurchaseWeightChange(material) {
            if (material.num < 0.1) {
                material.num = 0.1; // 确保数量不小于最小值
            }
            // 数量变化时重新计算总价
            this.calculateTotalPrice(material);
        },

        /**
         * 发起采购-确认编辑原料
         */
        confirmEditMaterial(material) {
            if (!material.materialName || !material.num || !material.unit || !material.unitPrice || !material.supplierId) {
                this.$message.warning("请完善所有必填项（原料名称、数量、单位、单价、供应商）");
                return;
            }

            // 确保总价已正确计算
            this.calculateTotalPrice(material);

            // 根据supplierId匹配供应商名称
            const supplier = this.suppliers.find(s => s.supplierId === material.supplierId) || {};
            const supplierName = supplier.supplierName || "";

            this.$loading({ text: "正在保存原料信息..." });
            const request = material.id
                ? editPurchaseMaterial({
                    userId: localStorage.getItem("userId"),
                    id: material.id,
                    materialName: material.materialName,
                    num: material.num,
                    unit: material.unit,
                    unitPrice: material.unitPrice, // 新增单价参数
                    totalPrice: material.totalPrice, // 新增总价参数
                    supplierId: material.supplierId,
                    supplier: supplierName, // 新增传递供应商名称
                })
                : addPurchaseMaterial({
                    userId: localStorage.getItem("userId"),
                    orderNo: this.purchaseForm.orderNo,
                    materialName: material.materialName,
                    num: material.num,
                    unit: material.unit,
                    unitPrice: material.unitPrice, // 新增单价参数
                    totalPrice: material.totalPrice, // 新增总价参数
                    supplierId: material.supplierId,
                    supplier: supplierName, // 新增传递供应商名称
                });

            request
                .then((response) => {
                    if (!material.id) {
                        material.id = response.data.id; // 如果是新增，回填ID
                    }
                    material.isEditing = false;
                    this.$message.success("原料信息保存成功");
                })
                .catch((error) => {
                    console.error("保存原料信息异常:", error);
                    this.$message.error("网络异常，保存失败");
                })
                .finally(() => {
                    this.$loading().close();
                });
        },










    },
};
</script>

<style lang="scss" scoped>
.announcement-header {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    padding: 10px 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 15px;

    .announcement-icon {
        color: #faad14;
        font-size: 20px;
        margin-right: 10px;
    }
}

.device-table-container {
    display: flex;
    flex-direction: column;
    height: calc(100% - 60px);
    overflow: hidden;
}

// --- 自动滚动列表样式 ---
.checkin-overview-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .overview-header {
        display: flex;
        background-color: #f8f9fa;
        font-weight: 600;
        padding: 12px 0;
        border-bottom: 1px solid #e8e8e8;
        z-index: 10;

        .header-item {
            flex: 1;
            text-align: center;
            color: #333;
        }
    }

    .marquee-container {
        flex: 1;
        overflow: hidden;
    }

    .overview-body {
        animation: scroll-up-device-table 60s linear infinite;
        height: 100%;

        &:hover {
            animation-play-state: paused;
        }

        .overview-row {
            display: flex;
            align-items: center;
            padding: 10px 0;
            border-bottom: 1px dashed #f0f0f0;

            &:hover {
                background-color: #f8f9fa;
            }

            .body-item {
                flex: 1;
                text-align: center;
                color: #666;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .empty-tip {
            text-align: center;
            padding: 50px 0;
            color: #999;
        }
    }
}

// 设备列表滚动动画
@keyframes scroll-up-device-table {
    0% {
        transform: translateY(0);
    }

    100% {
        transform: translateY(calc(-100% + 30vh));
    }
}
</style>